import { useState } from 'react'
import TicketMessaggiService from '../services/TicketMessaggiService/TicketMessaggiService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useTicketMessaggi = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingTicketMessaggioCreating: false,
    isLoadingTicketMessaggioDelete: false,
    isLoadingTicketMessaggioUpdate: false,
    isLoadingTicketMessaggiByParams: false,
  });

  const [modalState, setModalState] = useState({
    showModalInfoTicketMessaggio: false,
    showModalCreateTicketMessaggio: false,
    showModalDeleteTicketMessaggio: false,
    showModalUpdateTicketMessaggio: false
  });

  const getTicketMessaggiByParams = async (params) => {
    setLoadingState({ ...loadingState, isLoadingTicketMessaggiByParams: true });
    try {
      let obj;
      let response = await TicketMessaggiService.getTicketMessaggiByParams(params);
      const res = await response.json();
      const totalRecord = response.headers.get('X-Total-Record');
      obj = {
        data: res,
        count: totalRecord
      }
      return obj
    } catch (err) {
      handleError(err)
    } finally {
      setLoadingState({ ...loadingState, isLoadingTicketMessaggiByParams: false });
    }
  }

  const createTicketMessaggio = async (data) => {
    setLoadingState({ ...loadingState, isLoadingTicketMessaggioCreating: true });
    try {
      let response = await TicketMessaggiService.createTicketMessaggio(data);
      alertService.success("Messaggio del ticket creato con successo", {autoClose: true});
      setModalState({...modalState, showModalCreateTicketMessaggio: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingTicketMessaggioCreating: false });
    }
  }

  const deleteTicketMessaggio = async (id) => {
    try {
      setLoadingState({ ...loadingState, isLoadingTicketMessaggioDelete: true });
      let response = await TicketMessaggiService.deleteTicketMessaggio(id);
      const res = await response.json();
      alertService.success("Messaggio del ticket eliminato con successo", {autoClose: true});
      setModalState({...modalState, showModalDeleteTicketMessaggio: false });
      return res;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingTicketMessaggioDelete: false });
    }
  }

  const updateTicketMessaggio = async (data) => {
    try {
      setLoadingState({ ...loadingState, isLoadingTicketMessaggioUpdate: true });
      let response = await TicketMessaggiService.updateTicketMessaggio(data);
      alertService.success("Messaggio del ticket aggiornato con successo", {autoClose: true});
      setModalState({...modalState, showModalUpdateTicketMessaggio: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingTicketMessaggioUpdate: false });
    }
  }

  return {
    createTicketMessaggio,
    loadingStateTicketMessaggio: loadingState,
    modalStateTicketMessaggio: modalState,
    setModalStateTicketMessaggio: setModalState,
    updateTicketMessaggio,
    deleteTicketMessaggio,
    getTicketMessaggiByParams
  };
}

export default useTicketMessaggi;

